import type { UseQueryOptions } from '@tanstack/react-query';

import { getTemplate, type KyInstance, type Template, type TemplateQuery } from '@enterprise/api';
import type { OperationResultWithData } from '@enterprise/types';

import { datastreamQueryKeys } from '@/common/query-keys';

export const createTemplateQuery = (
  instance: KyInstance,
  query: TemplateQuery
): UseQueryOptions<OperationResultWithData<Template>, Error, Template | null> => {
  return {
    queryFn: async () => {
      return getTemplate(instance, query);
    },
    queryKey: datastreamQueryKeys.template.byIdOrName(query),
    retry: true,
    select: (result) => {
      if (result.failure) {
        return null;
      }

      return result.data;
    },
  };
};
